module.exports = __webpack_public_path__ + "static/chart-4x.f69fd79d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/chart-4x.png
// module id = 170
// module chunks = 95715928098905 173670457132349